module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('b', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292753952_07_for"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292753952_08_ack"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292753952_10_int"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")]), _vm._v(". "), _c('i', [_vm._v("“A place of unique, sensual beauty”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_11_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")]), _vm._v(". "), _c('i', [_vm._v("“A thousand little devils, shrieking and whistling”")]), _vm._v(" September 8, 1900")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_12_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TWO")]), _vm._v(". "), _c('i', [_vm._v("“You brave people of Galveston”")]), _vm._v(" From Wreckage to Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_13_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER THREE")]), _vm._v(". "), _c('i', [_vm._v("“Everything that mortal men can do”")]), _vm._v(" Protecting Galveston Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    staticStyle: {
      "margin-bottom": "0em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_14_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(". "), _c('i', [_vm._v("“To attain that superior success”")]), _vm._v(" Recovery and Growth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_15_conc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONCLUSION")]), _vm._v(". "), _c('i', [_vm._v("“I will never forget those days”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_16_bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BIBLIOGRAPHICAL ESSAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292753952_17_index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a39337","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292753952_06_toc.vue
// module id = 72
// module chunks = 0